export async function getImageSize(image) {
  if (!image) {
    return null;
  }

  if (Array.isArray(image)) {
    image = { ...image };
  }

  if (image.width && image.height) {
    return { width: image.width, height: image.height };
  }

  // Check if the image is a File object or a URL string
  let file;
  if (image instanceof File) {
    file = image; // If the image is a File object (from an <input> or drag-drop)
  } else if (typeof image.url === 'string') {
    // If the image is a URL (image.key is the URL)
    console.log(image.url);
    file = image.url;
  }

  if (file) {
    const img = new Image();
    img.src = file; // Directly use the URL for image source

    return new Promise((resolve, reject) => {
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = (err) => {
        reject(`Failed to load image: ${err}`);
      };
    });
  }

  return null;
}
